import React, {useEffect} from 'react';
import moment from 'moment';

import {
   Image,
   StyleSheet,
   Text,
   TouchableOpacity,
   TouchableWithoutFeedback,
   View,
   Dimensions,
   Platform,
   SafeAreaView,
} from 'react-native';
//import Slider from 'react-native-slider';
import Slider from '../../components/slider';
import {
   FONT_FAMILY_BOLD,
   FONT_FAMILY_REGULAR,
   WHITE_ICON_HOVER_TINT_COLOR,
   aslCloseHandler,
   bottomControllEllipseBG,
   isTabletMob,
   isiOS,
   white,
} from '../../utils/utils';
import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
   getIsTabletPortrait,
   selectLandscapeSmallWebView,
   selectScreenOrientation,
} from '../../redux/slices/ScreenOrientationSlice';
import {
   isChrome,
   isTablet as isTabletForWeb,
   isSafari,
} from 'react-device-detect';

const BottomControll = props => {
   const [showVolumeBar, setShowVolumeBar] = useState(false);
   const isTablet = useSelector(selectScreenOrientation);
   const isLandscapeMode = useSelector(selectScreenOrientation);

   const marginAndSize = {
      height: isTablet ? 45 : 30,
      width: isTablet ? 45 : 30,
      marginRight: 8,
   };

   const roundView = {
      marginRight: 8,
      height: isTablet ? 40 : 30,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: isTablet ? 15 : 10,
      paddingVertical: 4,
      borderRadius: isTablet ? 22 : 15,
      backgroundColor: bottomControllEllipseBG,
   };

   const isWeb = Platform.OS === 'web';
   const isWindows = Platform.OS === 'windows';
   const isMacos = Platform.OS === 'macos';
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const userAgent = isWeb ? window.navigator.userAgent : null;
   const iPhoneBrowser = userAgent?.includes('iPhone OS');
   const isTabletPortrait = useSelector(getIsTabletPortrait);
   const isPadChromeBrowser = userAgent?.includes('iPad') && isChrome;
   const [isBackForwardHover, setBackForwardHover] = useState(false);
   const [isPausIconHover, setPausIconHover] = useState(false);
   const [isPlayIconHover, setPlayIconHover] = useState(false);
   const [isNextForwardIconHover, setNextForwardIconHover] = useState(false);
   const [isVolumeIconHover, setVolumeIconHover] = useState(false);
   const [isFeedbackVideoIconHover, setFeedbackVideoIconHover] =
      useState(false);
   const [isUnionIconHover, setUnionIconHover] = useState(false);
   const [isHomevideoIconHover, setHomevideoIconHover] = useState(false);
   const [isFullScrenIconHover, setFullScrenIconHover] = useState(false);
   const iPhoneChromeBrowser = userAgent?.includes('iPhone OS') && isChrome;
   const isVolumeControlHidden =
      isPadChromeBrowser ||
      iPhoneChromeBrowser ||
      (isSafari && isTabletForWeb) ||
      (isSafari && !isLandscapeMode)
         ? true
         : false;
   // alert(userAgent);
   const dispatch = useDispatch();
   const aslBackHandler = () => {
      aslCloseHandler(dispatch);
   };
   return (
      <SafeAreaView
         style={[
            {
               backgroundColor: '#202020',
               paddingTop: isLandscapeMode ? 10 : 5,
            },
            !isiOS && {
               paddingLeft: isLandscapeMode || props.isReviewTest ? 16 : 6,
               paddingRight: isLandscapeMode || props.isReviewTest ? 16 : 6,
            },
            isMacos && {
               height: props.isReviewTest ? '8%' : '11%',
               justifyContent: props.isReviewTest ? 'center' : 'space-evenly',
               alignSelf: props.isReviewTest ? 'flex-end' : null,
               paddingTop: props.isReviewTest ? 0 : 8,
            },
            {
               ...Platform.select({
                  web: {
                     height: null,
                     paddingBottom: isTabletForWeb ? 15 : 10,
                     paddingTop: isTabletForWeb ? 15 : 10,
                  },
                  ios: {
                     height: isTablet
                        ? props.isReviewTest
                           ? 75
                           : 82
                        : props.isReviewTest
                        ? 60
                        : 72,
                     marginVertical: props.isReviewTest
                        ? null
                        : isTablet
                        ? 15
                        : 10,
                     marginTop: props.isReviewTest ? (isTablet ? 10 : 5) : null,
                     justifyContent: props.isReviewTest
                        ? 'center'
                        : 'flex-start',
                  },
                  android: {
                     height: isLandscapeMode
                        ? null
                        : isTablet
                        ? props.isReviewTest
                           ? 60
                           : 82
                        : props.isReviewTest
                        ? 50
                        : 72,
                     paddingBottom: isTablet ? 15 : 10,
                     paddingTop: isTablet ? 15 : 10,
                  },
                  windows: {
                     paddingTop: null,
                     height: props.isVideo ? 85 : null,
                     //backgroundColor: 'red',
                  },
               }),
            },
         ]}>
         {!props.isReviewTest && (
            <Slider
               value={props.currentTime}
               minimumValue={props.minimumValue}
               {...(!isWeb && {
                  onValueChange: value => props?.onSeekBarValueChange(value),
               })}
               {...(isWeb && {
                  onSlidingComplete: value =>
                     props?.onSeekBarSlidingComplete(value),
               })}
               disabled={props.disabled}
               maximumValue={props.maximumValue}
               thumbTouchSize={props.thumbTouchSize}
               thumbStyle={props.thumbStyle}
               minimumTrackTintColor={props.minimumTrackTintColor}
               maximumTrackTintColor={props.maximumTrackTintColor}
               trackStyle={props.trackStyle}
               style={props.style}
               thumbTintColor={props.thumbTintColor}
            />
         )}

         <TouchableWithoutFeedback
            onPress={() => {
               if (props.isVideo && isWindows) {
                  props.focusWin();
               }
            }}>
            <View
               style={[
                  styles.bottomView,
                  isWeb &&
                     !isLandscapeMode &&
                     !isLandscapeSmallWebView && {
                        ...Platform.select({
                           web: {
                              paddingStart: 0,
                              justifyContent: 'space-between',
                           },
                        }),
                     },
                  {
                     ...Platform.select({
                        web: {
                           height: null,
                           paddingVertical: 0,
                           paddingTop:
                              isTabletForWeb && !props.isReviewTest ? 5 : null,
                           alignItems: 'flex-start',
                        },
                        ios: {
                           paddingHorizontal: props.isReviewTest
                              ? isLandscapeMode
                                 ? 20
                                 : 16
                              : null,
                           paddingTop: props.isReviewTest
                              ? isTablet
                                 ? 4
                                 : null
                              : 0,
                           paddingBottom: 0,
                           //backgroundColor: 'cyan',
                        },
                        android: {
                           paddingTop: 0,
                           paddingBottom: 0,
                        },
                        macos: {
                           paddingHorizontal: props.isReviewTest ? 4 : null,
                           //backgroundColor: 'cyan',
                        },
                     }),
                  },
               ]}>
               {/* <View style={{flex: 1, flexDirection: 'row', alignItems: 'center'}}>

    </View> */}
               {props.isVideo && (
                  <View
                     style={{
                        flex: isLandscapeMode
                           ? 0.27
                           : isLandscapeSmallWebView
                           ? 0.1
                           : 0,
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        // position: 'absolute',
                        ...Platform.select({
                           web: {
                              // left: -10,
                              // width: '45%',
                           },
                        }),
                     }}>
                     {(isWindows || isMacos || isWeb) &&
                        isLandscapeMode &&
                        props.isVideo && (
                           <View
                              style={{
                                 flex: null,
                                 flexDirection: 'row',
                                 alignItems: 'center',
                                 justifyContent: 'flex-start',
                                 // marginLeft: isWindows ? 0 : 16,
                              }}>
                              <TouchableOpacity
                                 onMouseEnter={() => {
                                    setBackForwardHover(true);
                                 }}
                                 onMouseLeave={() => {
                                    setBackForwardHover(false);
                                 }}
                                 onPress={() => props.previousSlide()}>
                                 <View
                                    style={{
                                       alignItems: 'center',
                                       backgroundColor: '#454545',
                                       height: 48,
                                       width: 48,
                                       justifyContent: 'center',
                                       borderRadius: 25,
                                    }}>
                                    <Image
                                       source={require('../../assets/back_forward_player.png')}
                                       style={{
                                          opacity:
                                             props.currentSlide === 0 ? 0.5 : 1,
                                          height: 40,
                                          width: 40,
                                          tintColor: isBackForwardHover
                                             ? WHITE_ICON_HOVER_TINT_COLOR
                                             : '#FFF',
                                       }}
                                    />
                                 </View>
                              </TouchableOpacity>
                              <TouchableOpacity
                                 onMouseEnter={() => {
                                    setPausIconHover(true);
                                    setPlayIconHover(true);
                                 }}
                                 onMouseLeave={() => {
                                    setPausIconHover(false);
                                    setPlayIconHover(false);
                                 }}
                                 style={{marginStart: 8}}
                                 onPress={() => {
                                    props.onPlayPauseClick();
                                 }}>
                                 <View
                                    style={{
                                       alignItems: 'center',
                                       backgroundColor: '#454545',
                                       height: 48,
                                       width: 48,
                                       justifyContent: 'center',
                                       borderRadius: 25,
                                    }}>
                                    <Image
                                       source={
                                          props.isPlaying
                                             ? require('../../assets/paush.png')
                                             : require('../../assets/play.png')
                                       }
                                       style={{
                                          height: 20,
                                          width: 20,
                                          tintColor:
                                             isPlayIconHover || isPausIconHover
                                                ? WHITE_ICON_HOVER_TINT_COLOR
                                                : '#FFF',
                                       }}
                                    />
                                 </View>
                              </TouchableOpacity>
                              {props.isNextEnable ? (
                                 <TouchableOpacity
                                    onMouseEnter={() => {
                                       setNextForwardIconHover(true);
                                    }}
                                    onMouseLeave={() => {
                                       setNextForwardIconHover(false);
                                    }}
                                    style={{marginStart: 8}}
                                    onPress={() => props.nextSlide()}>
                                    <View
                                       style={{
                                          alignItems: 'center',
                                          backgroundColor: '#454545',
                                          height: 48,
                                          width: 48,
                                          justifyContent: 'center',
                                          borderRadius: 25,
                                       }}>
                                       <Image
                                          source={require('../../assets/next_forward_payer.png')}
                                          style={{
                                             opacity:
                                                props.currentSlide ===
                                                props.totalSlide - 1
                                                   ? 0.5
                                                   : 1,
                                             height: 40,
                                             width: 40,
                                             tintColor: isNextForwardIconHover
                                                ? WHITE_ICON_HOVER_TINT_COLOR
                                                : white,
                                          }}
                                       />
                                    </View>
                                 </TouchableOpacity>
                              ) : null}
                              {!isVolumeControlHidden && (
                                 <TouchableOpacity
                                    onMouseEnter={() => {
                                       setVolumeIconHover(true);
                                    }}
                                    onMouseLeave={() => {
                                       setVolumeIconHover(false);
                                    }}
                                    onPress={() =>
                                       setShowVolumeBar(!showVolumeBar)
                                    }>
                                    <View
                                       style={[
                                          styles.roundView2,
                                          marginAndSize,
                                          {
                                             marginLeft: 8,
                                          },
                                       ]}>
                                       <Image
                                          source={require('../../assets/volume.png')}
                                          style={{
                                             height: isTablet ? 20 : 12,
                                             width: isTablet ? 22 : 12,
                                             tintColor: isVolumeIconHover
                                                ? WHITE_ICON_HOVER_TINT_COLOR
                                                : white,
                                          }}
                                       />
                                    </View>
                                 </TouchableOpacity>
                              )}
                              {showVolumeBar && (
                                 <Slider
                                    style={{
                                       width: 80,
                                       height: 5,
                                       padding: 0,
                                       marginStart: 0,
                                       ...Platform.select({
                                          web: {
                                             cursor: 'pointer',
                                             marginTop: 10,
                                          },
                                       }),
                                    }}
                                    value={props.volume}
                                    minimumValue={0}
                                    maximumValue={1}
                                    {...(!isWeb && {
                                       onValueChange: value =>
                                          props.onVolumeChage(value),
                                    })}
                                    {...(isWeb && {
                                       onSlidingComplete: value =>
                                          props.onVolumeChage(value),
                                    })}
                                    thumbStyle={{height: 15, width: 15}}
                                    thumbTouchSize={{width: 30, height: 30}}
                                    minimumTrackTintColor="#6E8EFF"
                                    maximumTrackTintColor="#585858"
                                    trackStyle={{
                                       borderRadius: 2,
                                       backgroundColor: '#585858',
                                    }}
                                    thumbTintColor="#6E8EFF"
                                 />
                              )}
                           </View>
                        )}
                     {!((isWindows || isMacos || isWeb) && isLandscapeMode) && (
                        <>
                           {!isVolumeControlHidden && (
                              <TouchableOpacity
                                 onMouseEnter={() => {
                                    setVolumeIconHover(true);
                                 }}
                                 onMouseLeave={() => {
                                    setVolumeIconHover(false);
                                 }}
                                 onPress={() =>
                                    setShowVolumeBar(!showVolumeBar)
                                 }>
                                 <View
                                    style={[
                                       styles.roundView2,
                                       marginAndSize,
                                       {
                                          marginLeft: 0,
                                       },
                                       isWeb &&
                                          !isLandscapeMode &&
                                          !isLandscapeSmallWebView && {
                                             ...Platform.select({
                                                web: {
                                                   position: 'absolute',
                                                   bottom: 52,
                                                   left: -2,
                                                },
                                             }),
                                          },
                                    ]}>
                                    <Image
                                       source={require('../../assets/volume.png')}
                                       style={{
                                          height: isTablet ? 20 : 14,
                                          width: isTablet ? 21 : 15,
                                          tintColor:
                                             isVolumeIconHover &&
                                             WHITE_ICON_HOVER_TINT_COLOR,
                                       }}
                                    />
                                 </View>
                              </TouchableOpacity>
                           )}

                           {showVolumeBar && !isVolumeControlHidden && (
                              <Slider
                                 style={[
                                    {
                                       width: 80,
                                       maxWidth: 80,
                                       height: 5,
                                       padding: 0,
                                       marginStart: 0,
                                       ...Platform.select({
                                          web: {
                                             cursor: 'pointer',
                                             marginTop: 10,
                                             minWidth: 80,
                                          },
                                       }),
                                    },
                                    isWeb &&
                                       !isLandscapeMode &&
                                       !isLandscapeSmallWebView && {
                                          ...Platform.select({
                                             web: {
                                                position: 'absolute',
                                                bottom: 54,
                                                left: 48,
                                             },
                                          }),
                                       },
                                 ]}
                                 value={props.volume}
                                 minimumValue={0}
                                 maximumValue={1}
                                 {...(!isWeb && {
                                    onValueChange: value =>
                                       props.onVolumeChage(value),
                                 })}
                                 {...(isWeb && {
                                    onSlidingComplete: value =>
                                       props.onVolumeChage(value),
                                 })}
                                 thumbStyle={{height: 15, width: 15}}
                                 thumbTouchSize={{width: 30, height: 30}}
                                 minimumTrackTintColor="#6E8EFF"
                                 maximumTrackTintColor="#585858"
                                 trackStyle={{
                                    borderRadius: 2,
                                    backgroundColor: '#585858',
                                 }}
                                 thumbTintColor="#6E8EFF"
                              />
                           )}
                        </>
                     )}
                  </View>
               )}
               {isLandscapeMode && !isTabletPortrait && (
                  <View
                     style={{
                        flex: props.isReviewTest
                           ? 8
                           : isLandscapeMode
                           ? null
                           : 1,
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: -1,
                        height: isTablet ? 45 : 30,
                     }}>
                     <Text
                        style={{
                           maxWidth: 320,
                           fontSize: 14,
                           fontWeight: '700',
                           fontFamily: FONT_FAMILY_BOLD,
                           color: 'white',
                           flexWrap: 'wrap',
                           textAlign: 'center',
                           ...Platform.select({
                              web: {
                                 whiteSpace: 'initial',
                              },
                           }),
                        }}>
                        {props.slideTitle}
                     </Text>
                  </View>
               )}

               <View
                  style={{
                     flexDirection: 'row',
                     alignItems: 'center',
                     justifyContent:
                        isWeb && !isLandscapeMode && !isLandscapeSmallWebView
                           ? 'space-between'
                           : 'flex-end',
                     flex: !props.isReviewTest
                        ? isLandscapeMode
                           ? 0.5
                           : isLandscapeSmallWebView
                           ? 0.6
                           : 1
                        : isLandscapeMode
                        ? 0.22
                        : 1,
                     marginStart: 0,
                     marginBottom: isTablet ? 0 : props.isReviewTest ? 0 : 5,
                  }}>
                  <TouchableOpacity
                     onPress={() => props.onFeedbackClick()}
                     onMouseEnter={() => {
                        setFeedbackVideoIconHover(true);
                     }}
                     onMouseLeave={() => {
                        setFeedbackVideoIconHover(false);
                     }}>
                     <View style={[styles.roundView2, marginAndSize]}>
                        <Image
                           source={require('../../assets/feedback_video.png')}
                           style={{
                              height: isTablet ? 20 : 14,
                              width: isTablet ? 20 : 14,
                              tintColor: isFeedbackVideoIconHover
                                 ? WHITE_ICON_HOVER_TINT_COLOR
                                 : white,
                           }}
                        />
                     </View>
                  </TouchableOpacity>
                  {props.isVideo && (
                     <View
                        style={[
                           roundView,
                           {width: !isTablet ? 90 : 100},
                           {
                              ...Platform.select({
                                 web: {
                                    minWidth: !isLandscapeMode ? 120 : 110,
                                 },
                              }),
                           },
                        ]}>
                        <Text
                           style={{
                              fontSize: 10,
                              fontFamily: FONT_FAMILY_REGULAR,
                              color: 'white',
                              fontWeight: '700',
                           }}>
                           {millisToMinutesAndSeconds(props.currentTime)} /{' '}
                           {millisToMinutesAndSeconds(props.duration)}
                        </Text>
                     </View>
                  )}
                  {/* List */}
                  <TouchableOpacity
                     onPress={() => {
                        aslBackHandler();
                        setTimeout(() => {
                           props.onListPress();
                        }, 100);
                     }}
                     onMouseEnter={() => {
                        setUnionIconHover(true);
                     }}
                     onMouseLeave={() => {
                        setUnionIconHover(false);
                     }}>
                     <View style={[styles.roundView2, marginAndSize]}>
                        <Image
                           source={require('../../assets/Union.png')}
                           style={{
                              height: isTablet ? 18 : 12,
                              width: isTablet ? 20 : 14,
                              tintColor: isUnionIconHover
                                 ? WHITE_ICON_HOVER_TINT_COLOR
                                 : white,
                           }}
                        />
                     </View>
                  </TouchableOpacity>
                  <View
                     style={[
                        roundView,
                        {
                           minWidth: !isLandscapeMode ? null : 110,
                        },
                     ]}>
                     <Image
                        style={{
                           width: isLandscapeMode ? 16 : 14,
                           height: isLandscapeMode ? 16 : 14,
                           tintColor: white,
                           ...Platform.select({
                              web: {
                                 width: isLandscapeMode ? 16 : 14,
                                 height: isLandscapeMode ? 16 : 14,
                                 tintColor: white,
                              },
                           }),
                        }}
                        source={require('../../assets/topics_video.png')}
                     />

                     <Text
                        style={{
                           fontSize: 10,
                           fontFamily: FONT_FAMILY_REGULAR,
                           color: 'white',
                           marginStart: 16,
                           fontWeight: '700',
                        }}>
                        {props.currentSlide + 1} / {props.totalSlide}
                     </Text>
                  </View>
                  {/* Home Icon */}
                  <TouchableOpacity
                     onPress={() => {
                        aslBackHandler();
                        setTimeout(() => {
                           props.onHomePress();
                        }, 100);
                     }}
                     onMouseEnter={() => {
                        setHomevideoIconHover(true);
                     }}
                     onMouseLeave={() => {
                        setHomevideoIconHover(false);
                     }}>
                     <View
                        style={[
                           styles.roundView2,
                           marginAndSize,
                           !isWeb && {
                              marginRight: 0,
                           },
                           isWeb &&
                              ((!isLandscapeMode && !isLandscapeSmallWebView) ||
                                 iPhoneBrowser ||
                                 isPadChromeBrowser) && {
                                 ...Platform.select({
                                    web: {
                                       marginRight: 0,
                                       justifyContent: 'center',
                                       right:
                                          !isLandscapeMode &&
                                          !isLandscapeSmallWebView
                                             ? -4
                                             : 0,
                                    },
                                 }),
                              },
                        ]}>
                        <Image
                           source={require('../../assets/home_video.png')}
                           style={{
                              height: isTablet ? 20 : 15,
                              width: isTablet ? 20 : 15,
                              tintColor: isHomevideoIconHover
                                 ? WHITE_ICON_HOVER_TINT_COLOR
                                 : white,
                           }}
                        />
                     </View>
                  </TouchableOpacity>
                  {isWeb && !iPhoneBrowser && !isPadChromeBrowser && (
                     <TouchableOpacity
                        onPress={() => props.toggleFullScreen()}
                        onMouseEnter={() => {
                           setFullScrenIconHover(true);
                        }}
                        onMouseLeave={() => {
                           setFullScrenIconHover(false);
                        }}>
                        <View
                           style={[
                              styles.roundView2,
                              marginAndSize,
                              !isLandscapeMode &&
                                 !isLandscapeSmallWebView && {
                                    ...Platform.select({
                                       web: {
                                          position: props.isReviewTest
                                             ? 'relative'
                                             : 'absolute',
                                          bottom:
                                             isLandscapeMode ||
                                             props.isReviewTest
                                                ? null
                                                : 68,
                                          right: -2,
                                       },
                                    }),
                                 },
                              {
                                 marginRight: 0,
                              },
                           ]}>
                           <Image
                              source={require('../../assets/fullscreen.png')}
                              style={{
                                 height: isTablet ? 20 : 16,
                                 width: isTablet ? 20 : 16,
                                 tintColor: isFullScrenIconHover
                                    ? WHITE_ICON_HOVER_TINT_COLOR
                                    : white,
                              }}
                           />
                        </View>
                     </TouchableOpacity>
                  )}
               </View>
            </View>
         </TouchableWithoutFeedback>
      </SafeAreaView>
   );
};

function millisToMinutesAndSeconds(second) {
   const momentDuration = moment.duration(second, 'seconds');
   const hours = momentDuration.hours().toString().padStart(2, '0');
   const minutes = momentDuration.minutes().toString().padStart(2, '0');
   const seconds = momentDuration.seconds().toString().padStart(2, '0');
   if (hours === '00') {
      return `${minutes}:${seconds}`;
   }
   return `${hours}:${minutes}:${seconds}`;
}

const styles = StyleSheet.create({
   bottomView: {
      flexDirection: 'row',
      alignContent: 'center',
      paddingVertical: 10,
      alignItems: 'center',
      width: '100%',
      justifyContent: 'space-between',
   },

   roundView2: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: 8,
      borderRadius: 50,
      backgroundColor: '#313131',
   },

   controlView: {
      height: 20,
      width: 20,
      marginRight: 16,
      alignItems: 'center',
      justifyContent: 'center',
      padding: 4,
      borderRadius: 50,
      position: 'absolute',
      backgroundColor: '#101010',
   },
   videoView: {
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
   },
});

export default BottomControll;
